// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"146":"ac07fc2e","820":"4aa2d72e"}[chunkId] + ".css";
};